export const situacaoPropriedade = [
  //Array de Opções usadas no SELECT de dias da semana
  { id: 1, label: "Escriturado", value: "ESCRITURADO" },
  { id: 2, label: "Quitado", value: "QUITADO" },
  { id: 3, label: "Não Quitado", value: "NAO_QUITADO" },
  { id: 4, label: "Na planta", value: "NA_PLANTA" },
];
